import { useState, useEffect } from 'react';
import { styles2, renderPreText, fetchData, headerWithLink, headerWIthMultipleLines } from './Helpers';
import NewsLicensePli from './NewsLicensePli';

export default function NewsPackages({tab}) {
  const [fullData, setFullData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pliFlag, setPliFlag] = useState(false);

  const headers = {
    "News_Reuters_News": "Reuters Equity & Markets News Proposition Detail",
    "News_3rd_Party_News": "3rd Party Newswire Proposition Detail",
    "News_Top_News": "Top News",
    "News_Online_Reports": "Online Reports",
    "News_Breakingviews": "Breaking Views",
    "News_Significant_Development": "Significant Developments Service",
    "News_Japanese_Investor_Brief": "Japanese Investor Briefs"
  }

  function searchEvent(val) {    
    setSearchData(fullData.filter(item => item.packageType.toLowerCase().includes(val.toLowerCase())));
  }

  useEffect(() => {
    fetchData(tab).then((res) => {
      setFullData(res.filter(item => item.packageType !== "PLI"));
      setLoading(false);
    });
  }, [tab]);

  useEffect(() => {
    const grid = document.getElementById('grid');
    let columns = [
      { name: 'Package Type', field: 'packageType', width: 2, scalable: true, styles: styles2},
      { name: 'PUBLIC', field: 'public', width: 3, scalable: true, binding: renderPreText, headerBinding: headerWithLink.bind(null, "Non Professional", "free") },
      { name: 'PRIVATE', field: 'nonprofessionalPrivate', width: 3, scalable: true, binding: renderPreText, headerBinding: headerWithLink.bind(null, "Non Professional", "private") },
      { name: 'INTERNAL PROFESSIONAL', field: 'internalProfessionalPrivate', width: 3, scalable: true, binding: renderPreText, headerBinding: headerWithLink.bind(null, "Private", "professional") }
    ]
    if(tab === "News_Reuters_News"){
      columns = [
        { name: 'Package Type', field: 'packageType', width: 2, scalable: true, styles: styles2},
        { name: 'Global Financial Market News Package', field: 'globalFinMarkets', width: 3, scalable: true, binding: renderPreText, headerBinding: headerWIthMultipleLines },
        { name: 'Equity & Markets News Package ', field: 'equityMarkets', width: 3, scalable: true, binding: renderPreText, headerBinding: headerWIthMultipleLines },
        { name: 'Premium Equity & Markets News \'Active Trader\' Package', field: 'premiumEquityMarkets', width: 3, scalable: true, binding: renderPreText, headerBinding: headerWIthMultipleLines },
        { name: 'Premium News Analytics Add-on' , field: 'PremiumNewsAnalyticsAddon', width: 3, scalable: true, binding: renderPreText, headerBinding: headerWIthMultipleLines }
      ]
    }
    if(tab === "News_3rd_Party_News"){
      columns = [
        { name: 'Package Type', field: 'packageType', width: 2, scalable: true, styles: styles2},
        { name: 'Third Party Newswire', field: 'thirdPartyNewsWire', width: 2, scalable: true, binding: renderPreText},
        { name: 'Premium News Analytics Add-on', field: 'PremiumNewsAnalyticsAddon', width: 2, scalable: true, binding: renderPreText},
      ]
    }

    function addFooter(grid) {
      const newSection = grid.api.addFooterSection("My_Footer");
      if(newSection) {
        newSection.setCellColSpan(0, 0, 1);
        newSection.setCellColSpan(1, 0, 4);
        newSection.getCell(0, 0).setContent("PLI");
        const content = document.createElement("div");
        const btnIcon = document.createElement("ef-icon");
        btnIcon.icon = "link";
        btnIcon.style.color = "blue";
        btnIcon.style.fontSize = "14px";
        btnIcon.style.verticalAlign = "text-top";
        const btn = document.createElement("button");
        btn.style.backgroundColor = "transparent";
        btn.style.border = "none";
        btn.style.color = "blue";
        btn.style.padding = "0";
        btn.style.textDecoration = "underline";
        btn.style.cursor = "pointer";
        btn.innerText = "News License PLI";
        btn.onclick = function() {
          setPliFlag(true);
        }
        content.appendChild(btnIcon);
        content.appendChild(btn);
        newSection.getCell(1, 0).setContent(content);
      }
    }

    if(!pliFlag){
      grid.config = {
        rowHeight: 150,
        headerRowHeight: 60,
        columns: columns,
        dataModel: {
          data: searchData.length > 0 ? searchData : fullData,
        },
        sorting: {
          sortableColumns: false,
          initialSort: {
              colIndex: 0, // Column index`
              sortOrder: "a"
          }
        }
      };
      grid.addEventListener('configured', () => {
        addFooter(grid);
      });
    }
  }, [fullData, searchData, tab, pliFlag]);

  return (
    <div className="inner-main-div">
      {pliFlag && (
        <div>
          <ef-button className="back-button" icon="back" onClick={() => setPliFlag(false)}>Back to {headers[tab]}</ef-button>
          <NewsLicensePli tab={tab} />
        </div>
      )}
      {!pliFlag && (<>
        <ef-loader class="loader" hidden={!loading}></ef-loader>
        <h4>{headers[tab]}</h4>
        <ef-layout flex style={{ marginTop: '20px' }}>
          <ef-layout>
            <input
              className='search-field'
              type="text"
              placeholder="Type to search..."
              onChange={(e) => searchEvent(e.target.value)}
            />
          </ef-layout>
        </ef-layout>
        <efx-grid id="grid" className="entity-grid"></efx-grid>
      </>)}
    </div>
  );
}